import { LogoWithName } from 'components/BrandLogo';

const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full shrink-0">
      <div className="flex min-h-[3.25rem] items-center rounded-2xl border border-border/40 bg-card px-3 py-2 shadow-sm sm:min-h-14 sm:px-4 sm:py-2.5 md:px-5">
        <div className="min-w-0 max-w-[70vw] sm:max-w-none">
          <LogoWithName className="h-7 max-h-7 sm:h-8 sm:max-h-8" />
        </div>
      </div>
    </header>
  );
};

export default Header;
